<du-lipo-detail [detailModel]="detailModel"
                [showLicenseWizardButton]="systemId !== null"
                (onDeleteClicked)="onDeleteClicked(systemId)"
                [isSaving]="isSaving"
                (onSaveClicked)="onSaveClick(detailModel!, systemId)"
                [menuButtons]="menuButtons"
                [navigateBack]="{commands: [LipoRouteEnum.SYSTEM]}"></du-lipo-detail>
